module.exports = __webpack_public_path__ + "assets/asset_shield.95af9691.svg";